import { useState } from "react";

type UseSidemenuProps = string[];
type SidemenuState = { [key: string]: { show: boolean } };

export function useSidemenu(props: UseSidemenuProps) {
  // Initialize the state for all sidebars
  const [sidemenus, setSidemenus] = useState<SidemenuState>(getSidemenus(props));

  // Function to toggle the visibility of a specific sidebar
  function toggleSidemenu(key: string) {
    const updatedSidemenus = { ...sidemenus };

    if (updatedSidemenus[key]) {
      updatedSidemenus[key].show = !updatedSidemenus[key].show;
      setSidemenus(updatedSidemenus);
    }
  }

  // Function to close all sidebars
  function closeAllSidemenus() {
    const updatedSidemenus = { ...sidemenus };
    for (const key in updatedSidemenus) {
      updatedSidemenus[key].show = false;
    }
    setSidemenus(updatedSidemenus);
  }

  return {
    sidemenus,
    toggleSidemenu,
    closeAllSidemenus,
  };
}

// Helper function to initialize the state for all sidebars
function getSidemenus(list: string[]) {
  const sidemenuList: SidemenuState = {};
  list.forEach((key) => (sidemenuList[key] = { show: false }));
  return sidemenuList;
}